import script from "./TerminalStatusView.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminalStatusView.vue?vue&type=script&setup=true&lang=js"

import "./TerminalStatusView.vue?vue&type=style&index=0&id=52a693e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a693e2"]])

export default __exports__